/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Giveawaystats_Sellers1Inputs */

const id_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjual`)
};

const ms_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjual`)
};

const da_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sælgere`)
};

const de_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkäufer`)
};

const en_us2_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sellers`)
};

const es_es2_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedores`)
};

const es_mx2_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedores`)
};

const fil_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Nagbebenta`)
};

const fr_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendeurs`)
};

const it_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venditori`)
};

const hu_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eladók`)
};

const nl_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkopers`)
};

const no_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selgere`)
};

const pl_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprzedawcy`)
};

const pt_br2_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sellers`)
};

const pt_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedores`)
};

const ro_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vânzători`)
};

const fi_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Myyjät`)
};

const sv_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säljare`)
};

const vi_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người bán`)
};

const tr_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satıcılar`)
};

const cs_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prodejci`)
};

const bg_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавачи`)
};

const ru_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавцы`)
};

const uk_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавці`)
};

const ar_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البائعون`)
};

const hi_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विक्रेता`)
};

const th_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้ขาย`)
};

const ja_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`販売元`)
};

const zh_cn2_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sellers`)
};

const zh_hant1_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sellers`)
};

const ko_components_giveawaystats_sellers1 = /** @type {(inputs: Components_Giveawaystats_Sellers1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sellers`)
};

/**
* | output |
* | --- |
* | "Sellers" |
*
* @param {Components_Giveawaystats_Sellers1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_giveawaystats_sellers1 = /** @type {((inputs?: Components_Giveawaystats_Sellers1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Giveawaystats_Sellers1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_giveawaystats_sellers1(inputs)
	if (locale === "ms") return ms_components_giveawaystats_sellers1(inputs)
	if (locale === "da") return da_components_giveawaystats_sellers1(inputs)
	if (locale === "de") return de_components_giveawaystats_sellers1(inputs)
	if (locale === "en-US") return en_us2_components_giveawaystats_sellers1(inputs)
	if (locale === "es-ES") return es_es2_components_giveawaystats_sellers1(inputs)
	if (locale === "es-MX") return es_mx2_components_giveawaystats_sellers1(inputs)
	if (locale === "fil") return fil_components_giveawaystats_sellers1(inputs)
	if (locale === "fr") return fr_components_giveawaystats_sellers1(inputs)
	if (locale === "it") return it_components_giveawaystats_sellers1(inputs)
	if (locale === "hu") return hu_components_giveawaystats_sellers1(inputs)
	if (locale === "nl") return nl_components_giveawaystats_sellers1(inputs)
	if (locale === "no") return no_components_giveawaystats_sellers1(inputs)
	if (locale === "pl") return pl_components_giveawaystats_sellers1(inputs)
	if (locale === "pt-BR") return pt_br2_components_giveawaystats_sellers1(inputs)
	if (locale === "pt") return pt_components_giveawaystats_sellers1(inputs)
	if (locale === "ro") return ro_components_giveawaystats_sellers1(inputs)
	if (locale === "fi") return fi_components_giveawaystats_sellers1(inputs)
	if (locale === "sv") return sv_components_giveawaystats_sellers1(inputs)
	if (locale === "vi") return vi_components_giveawaystats_sellers1(inputs)
	if (locale === "tr") return tr_components_giveawaystats_sellers1(inputs)
	if (locale === "cs") return cs_components_giveawaystats_sellers1(inputs)
	if (locale === "bg") return bg_components_giveawaystats_sellers1(inputs)
	if (locale === "ru") return ru_components_giveawaystats_sellers1(inputs)
	if (locale === "uk") return uk_components_giveawaystats_sellers1(inputs)
	if (locale === "ar") return ar_components_giveawaystats_sellers1(inputs)
	if (locale === "hi") return hi_components_giveawaystats_sellers1(inputs)
	if (locale === "th") return th_components_giveawaystats_sellers1(inputs)
	if (locale === "ja") return ja_components_giveawaystats_sellers1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_giveawaystats_sellers1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_giveawaystats_sellers1(inputs)
	return ko_components_giveawaystats_sellers1(inputs)
});
export { components_giveawaystats_sellers1 as "components.giveawayStats.sellers" }